// "Hand this device to the patient?" (UC-PATIENTS-022 step 1, A9, A10; BR-PATIENTS-041): the one question every staff button
// asks before it hands this device to a patient — Today's New patient, the record's Update on the kiosk and Re-consent on kiosk,
// and the check-in's Re-consent on kiosk. Any device can be handed over, a front-desk computer too: Today's New patient used to
// hand it over at once, and whoever pressed it meaning to type a new patient in found the screen locked (DVN's test checklist of
// Sprints 1 and 2, item D2). The question says what follows and how staff get back. Cancel and Escape send nothing and give the
// focus back to the button that asked; only Today offers the staff form instead.
import { useEffect, useState } from "react";
import { Link } from "react-router";
import { WRITE_BLOCK_TITLE, useWriteBlock } from "../shell/OfflineBanner";
import { Modal } from "../ui/bits";
import { Icon } from "../ui/icons";

export function ConfirmHandOver({ onHandOver, onCancel, typeDetailsAt }: {
  /** Hand to patient: the caller closes the question and starts the hand-over it asked about. */
  onHandOver: () => void;
  /** Cancel or Escape: nothing has been sent. */
  onCancel: () => void;
  /** The staff form offered instead, as "Type the details yourself" — Today's New patient, for a role that may create patients. */
  typeDetailsAt?: string | undefined;
}) {
  const block = useWriteBlock();
  // The button that asked, read before the dialog takes the focus; it has the focus again once the question closes.
  const [opener] = useState(() => (document.activeElement instanceof HTMLElement ? document.activeElement : null));
  useEffect(() => () => { if (opener?.isConnected) opener.focus(); }, [opener]);
  return (
    <Modal title="Hand this device to the patient?" className="handover" onClose={onCancel} onSubmit={() => { if (block === null) onHandOver(); }} footer={<>
      <button className="btn" type="button" onClick={onCancel}>Cancel</button>
      {typeDetailsAt && <Link className="btn" to={typeDetailsAt}>Type the details yourself</Link>}
      <button className="btn primary" type="submit" disabled={block !== null} title={block ? WRITE_BLOCK_TITLE[block] : undefined}><Icon name="lock" />Hand to patient</button>
    </>}>
      <p>The screen locks so the patient sees only their own form.</p>
      <p>To get back, press and hold <b>Staff: hold to exit</b> at the bottom right of the screen, then enter your Control PIN.</p>
    </Modal>
  );
}
